export default "__VITE_ASSET__ee021706__"